export default {
  namespaced: true,

  state: {
    files: [],
  },

  mutations: {
    ADD_FILES(state, files) {
      state.files.push(...files);
    },

    REMOVE_FILES(state, fileIds) {
      state.files = state.files.filter((file) => fileIds.indexOf(file.id) === -1);
    },

    CLEAR_FILES(state) {
      state.files.splice(0, state.files.length);
    },
  },

  actions: {
    addTempFiles({ commit, dispatch }, files) {
      commit('ADD_FILES', files);
      dispatch('dialog/clearDialog', {}, { root: true });
    },

    deleteTempFiles({ commit }, fileIds) {
      commit('REMOVE_FILES', fileIds);
    },

    clearTempFiles({ commit }) {
      commit('CLEAR_FILES');
    },
  },
};
